import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateFeaturePreview = (fpId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_FEATURE_PREVIEW' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/link-tokens/${fpId}`,
            payload,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_FEATURE_PREVIEW_DONE',
              payload: {
                fpId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(fpId);
            }
          } else {
            dispatch({
              type: 'UPDATING_FEATURE_PREVIEW_FAILED',
              payload: `Failed to update feature preview`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_FEATURE_PREVIEW_FAILED',
            payload: `Failed to update feature preview`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_FEATURE_PREVIEW_FAILED',
        payload: `Failed to update feature preview`,
      });
    }
  };
};

export default updateFeaturePreview;
